import { filter, Subject, tap } from 'rxjs';

export interface Event<T> {
  key: string;
  data: T;
}

export class EventBus<T> {
  #events: Subject<Event<T>> = new Subject();

  emit(key: string, data: T) {
    this.#events.next({ key, data });
  }

  on(key: string, callback: (data: Event<T>) => void) {
    return this.#events
      .asObservable()
      .pipe(
        filter((event) => event.key === key),
        tap(callback),
      )
      .subscribe();
  }
}
